import React, { PropsWithChildren, useCallback, useState } from 'react';
import { ContentItem } from '../utils/response-decoders';

type LtiResourceContextType = [ContentItem | undefined, (jwt?: string) => void];

export const LtiResourceContext = React.createContext<LtiResourceContextType>([
  undefined,
  () => {
    // no-op
  },
]);

type Props<T extends ContentItem | undefined> = {
  decodeLtiResponseJwt: (jwt: string) => T;
};

export function LtiResourceContextProvider<T extends ContentItem | undefined>({
  children,
  decodeLtiResponseJwt,
}: PropsWithChildren<Props<T>>) {
  const [ltiResource, setLtiResource] = useState<ContentItem | undefined>(undefined);

  const processLtiResponse = useCallback(
    (jwt?: string) => {
      if (jwt) {
        return setLtiResource(decodeLtiResponseJwt(jwt));
      }

      setLtiResource(undefined);
    },
    [decodeLtiResponseJwt],
  );

  return (
    <LtiResourceContext.Provider value={[ltiResource, processLtiResponse]}>{children}</LtiResourceContext.Provider>
  );
}
